import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, inject } from '@angular/core';
import { AuthInterceptor } from 'src/app/common/interceptors/auth.interceptor';
import { Extern } from 'src/app/extern';

@Component({
  selector: 'wct-doka',
  standalone: true,
  imports: [],
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DokaComponent implements AfterViewInit {
  @Input({ required: false }) public dokaOptions: Record<string, string> = undefined;
  @Input({ required: false }) public autobuild: boolean = true;

  private readonly element: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly extern = inject(Extern);
  private readonly auth?: AuthInterceptor = inject(HTTP_INTERCEPTORS).find(interceptor => interceptor instanceof AuthInterceptor) as AuthInterceptor | undefined;


  ngAfterViewInit(): void {
    const host: HTMLElement = this.element.nativeElement;

    if (!host) {
      throw new Error('doka element is undefined');
    }

    if (this.autobuild) {
      this.build();
    }
  }

  public build(): void {
    const host: HTMLElement = this.element.nativeElement;
    this.fetchUserDataAndBuildDoka(host);
  }

  private async fetchUserDataAndBuildDoka(host: HTMLElement): Promise<void> {
    try {
      const [userData, loginToken] = await Promise.all([
        this.auth.getLoginService()?.getUserData(),
        this.auth.getLoginService()?.getLoginToken(),
      ]);

      const authenticatedUserId = userData ? userData.profile['extension_uukey'] : undefined;

      while (host.childNodes.length > 0) {
        host.removeChild(host.lastChild);
      }

      this.extern.placeDoka(host, loginToken, authenticatedUserId, this.dokaOptions);
    } catch (error) {
      console.error('Error occurred:', error);
    }
  }
}
